import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import CsvImport from "../Common/CsvImport";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import XLSX from "xlsx";
import { globalServices } from "../../Services";

const BulkImportStep1 = ({ setData, handleCancel, generalError }) => {
  const { t: translator } = useTranslation();

  const { locTenant } = useContext(GlobalContext);

  const [unitOfMeasures, setUnitOfMeasures] = useState();
  const [taxRates, setTaxRates] = useState();
  const [itemGroups, setItemGroups] = useState();

  useEffect(() => {
    globalServices
      .getUnitOfMeasures()
      .then((res) => setUnitOfMeasures(res.data));
    globalServices.getTaxRates().then((res) => setTaxRates(res.data));
    globalServices
      .getItemGroups(locTenant)
      .then((res) => setItemGroups(res.data));
  }, []);

  const handleExport = () => {
    const itemsExample = [
      {
        id:"",
        name: "Sladoled",
        code: "",
        barCode: "ABCDE1234567890",
        description: "Kuglica sladoleda",
        isService: "Ne",
        pn: 0.1,
        unitOfMeasure: "kom",
        taxRate: "PDV 25",
        itemGroup: "Hrana",
        price: 143.21,
        pp: 3.5,
        classNumber: "01.11.10",
      },
      {
        id:"df1ff8e2-570e-4eb4-8580-bfe65708aaf4",
        name: "Grožđe",
        code: "G11",
        barCode: "",
        description: "Bijelo grožđe ",
        isService: "Ne",
        pn: 0,
        unitOfMeasure: "kom",
        taxRate: "PDV 13",
        itemGroup: "Piće",
        price: 24.21,
        pp: 0.13,
        classNumber: "01.13.20",
      },
    ];

    let wb = XLSX.utils.book_new();

    const wsItemsHeading = [
      [
        translator("Id"),
        translator("BulkImport-StepOne-Data-Name"),
        translator("BulkImport-StepOne-Data-Code"),
        translator("BulkImport-StepOne-Data-BarCode"),
        translator("BulkImport-StepOne-Data-Description"),
        translator("BulkImport-StepOne-Data-IsService"),
        translator("BulkImport-StepOne-Data-Pn"),
        translator("BulkImport-StepOne-Data-UnitOfMeasure"),
        translator("BulkImport-StepOne-Data-TaxRate"),
        translator("BulkImport-StepOne-Data-ItemGroup"),
        translator("BulkImport-StepOne-Data-Price"),
        translator("BulkImport-StepOne-Data-Pp"),
        translator("BulkImport-StepOne-Data-ClassNumber"),
      ],
    ];
    let wsItems = XLSX.utils.aoa_to_sheet(wsItemsHeading);
    XLSX.utils.sheet_add_json(wsItems, itemsExample, {
      header: [
        "id",
        "name",
        "code",
        "barCode",
        "description",
        "isService",
        "pn",
        "unitOfMeasure",
        "taxRate",
        "itemGroup",
        "price",
        "pp",
        "classNumber",
      ],
      skipHeader: true,
      origin: -1,
    });

    const wsItemGroupsHeading = [["Grupe artikala"]];
    let wsItemGroups = XLSX.utils.aoa_to_sheet(wsItemGroupsHeading);
    XLSX.utils.sheet_add_json(
      wsItemGroups,
      itemGroups.map((x) => {
        return { name: x.name };
      }),
      {
        header: ["name"],
        skipHeader: true,
        origin: -1,
      }
    );

    const wsUnitOfMeasureHeading = [["Naziv", "Oznaka"]];
    let wsUnitOfMeasure = XLSX.utils.aoa_to_sheet(wsUnitOfMeasureHeading);
    XLSX.utils.sheet_add_json(
      wsUnitOfMeasure,
      unitOfMeasures.map((x) => {
        return { name: x.name, code: x.code };
      }),
      {
        header: ["name", "code"],
        skipHeader: true,
        origin: -1,
      }
    );

    const wsTaxRateHeading = [["Porezne stope"]];
    let wsTaxRate = XLSX.utils.aoa_to_sheet(wsTaxRateHeading);
    XLSX.utils.sheet_add_json(
      wsTaxRate,
      taxRates.map((x) => {
        return { name: x.name };
      }),
      {
        header: ["name"],
        skipHeader: true,
        origin: -1,
      }
    );

    XLSX.utils.book_append_sheet(wb, wsItems, "Artikli");
    XLSX.utils.book_append_sheet(wb, wsItemGroups, "Grupe artikala");
    XLSX.utils.book_append_sheet(wb, wsUnitOfMeasure, "Jedinice mjera");
    XLSX.utils.book_append_sheet(wb, wsTaxRate, "Porezne stope");

    const fileName = "PrimjerCjenika.xlsx";
    XLSX.writeFile(wb, fileName);
  };

  return (
    <>
      <div>
        {translator("BulkImport-StepOne-Text")}
        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <td>{translator("BulkimportStep1-Name")}</td>
              <td>{translator("BulkimportStep1-Details")}</td>
            </tr>
          </thead>
          <tbody>
          <tr>
              <td>{translator("BulkImport-StepOne-Data-Id")}</td>
              <td>{translator("BulkImport-StepOne-Id")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Name")}</td>
              <td>{translator("BulkimportStep1-ArticleName")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Code")}</td>
              <td>{translator("BulkimportStep1-ArticleCode")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-BarCode")}</td>
              <td>{translator("BulkimportStep1-ArticleBarCode")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Description")}</td>
              <td>{translator("BulkimportStep1-ArticleDescription")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-IsService")}</td>
              <td>{translator("BulkimportStep1-ProductOrService")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Pn")}</td>
              <td>{translator("BulkimportStep1-AmountTaxComp")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-UnitOfMeasure")}</td>
              <td>{translator("BulkimportStep1-UnitOfMeasureTag")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-TaxRate")}</td>
              <td>{translator("BulkimportStep1-TaxRateName")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-ItemGroup")}</td>
              <td>{translator("BulkimportStep1-ItemGroupName")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Price")}</td>
              <td>{translator("BulkimportStep1-ItemPrice")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-Pp")}</td>
              <td>{translator("BulkimportStep1-ConsumTaxAmount")}</td>
            </tr>
            <tr>
              <td>{translator("BulkImport-StepOne-Data-ClassNumber")}</td>
              <td>{translator("BulkimportStep1-ClassNumber")}</td>
            </tr>
          </tbody>
        </table>
        <div className="mt-3">
          <p>
            {translator("BulkImport-StepOne-RequiredData")}
           
          </p>
        </div>
        <div className="mt-3">
          <p>
            {translator("BulkImport-StepOne-ExampleText")}{" "}
            <a href="#" onClick={handleExport}>
              {translator("BulkImport-StepOne-Link-Here")}
            </a>
            .
          </p>
        </div>
        {generalError && (
          <div className="invalid-record mb-3 p-3">{generalError}</div>
        )}
        <CsvImport setResult={setData} />
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
        </div>
      </div>
    </>
  );
};

export default BulkImportStep1;
